import { type CommonProps, type EventWithCount, ONBOARDING_EVENTS, trackEvent } from "."

// Work events
export const work = {
  landOn: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.WORK_LAND, props),
  selectWork: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.SELECT_HE_WORK, props),
  selectDidNotWork: (props: CommonProps) =>
    trackEvent(ONBOARDING_EVENTS.SELECT_HE_DID_NOT_WORK, props),
  addEvent: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.WORK_ADD_EVENT, props),
  removeEvent: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.WORK_REMOVE_EVENT, props),
  keepSaving: (props: EventWithCount<"workEventsCount">) =>
    trackEvent(ONBOARDING_EVENTS.WORK_KEEP_SAVING, props),
  goBackToChooseName: (props: CommonProps) => trackEvent(ONBOARDING_EVENTS.WORK_GO_BACK, props),
}
